import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'
import { notificationKeys } from './api'

export function useNotificationRealtime() {
  const qc = useQueryClient()
  useRealtime(
    () => true,
    (msg) => {
      const data = msg.data
      if (!data || typeof data !== 'object' || !('notification_id' in data)) return
      void qc.invalidateQueries({ queryKey: notificationKeys.all })
    },
  )
}
